import { Button } from '@/components/ui/button';
import { Card, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { useSessionStore } from '@/stores/session';
import { AuthScreen } from './AuthScreen';

// Effetá Apps no contestó al arrancar. La sesión puede seguir abierta, así que
// no se manda a entrar: el session store reintenta solo y el botón adelanta
// el próximo intento.
export const ProviderUnavailableScreen = () => {
  const boot = useSessionStore((s) => s.boot);

  return (
    <AuthScreen>
      <Card className="animate-fade-in w-full max-w-sm">
        <CardHeader className="text-center">
          <CardTitle>Effetá Apps no responde</CardTitle>
          <CardDescription role="status">
            No pudimos confirmar tu sesión porque Effetá Apps no responde en este momento. Volvemos
            a intentarlo en unos segundos.
          </CardDescription>
        </CardHeader>
        <CardFooter>
          <Button type="button" className="w-full" onClick={() => void boot()}>
            Reintentar ahora
          </Button>
        </CardFooter>
      </Card>
    </AuthScreen>
  );
};
